import React from "react";

import "./index.css";
import { Tooltip } from "antd";

const logoUrl = `${process.env.PUBLIC_URL}/logo/logo-dhl-small.png`;

const DhlLogo = ({ intl, intlId, hideText, defaultMessage }) => (
  <Tooltip
    overlayStyle={{
      whiteSpace: "pre-line",
      minWidth: defaultMessage.length > 40 ? 335 : 285,
    }}
    title={intl.formatMessage({
      id: intlId,
      defaultMessage,
    })}
  >
    <img
      alt="logo"
      src={logoUrl}
      className={hideText ? "logo-dhl-small-no-text" : "logo-dhl-small"}
    />
  </Tooltip>
);

export default DhlLogo;
